import PropTypes from 'prop-types';
import { isEmpty, map, sortBy, uniqueId } from 'lodash';
import { FormattedMessage } from 'react-intl';
import AllOrOne from "../../AllOrOne/AllOrOne";
import Location from "../Location/Location";
import addresses from "../../../utils/Addresses";
import cn from "../../../../utils/cn";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Locations = _ref => {
  let {
    className = '',
    clickableAddress = false,
    hideLocationName = false,
    isInNetworkGroup = true,
    locations = [],
    originLatLng = [],
    showCount = true,
    showMore = false,
    locationAdditionalContentComponent = null,
    intlProvider = {},
    showHoursIcon = false
  } = _ref;
  const calculatedDistances = map(locations, location => addresses.calculateDistance(location, originLatLng));
  const formattedLocations = sortBy(calculatedDistances, 'distanceVal') || [];
  let locationText;
  if (formattedLocations.length === 1) {
    locationText = !isEmpty(intlProvider) ? /*#__PURE__*/_jsx(FormattedMessage, {
      id: "UdrOGf",
      description: "location-singular",
      defaultMessage: "Location",
      children: txt => /*#__PURE__*/_jsx("h4", {
        className: "text-sm text-text-blue font-heavy-font",
        children: "".concat(formattedLocations.length, " ").concat(txt)
      })
    }) : /*#__PURE__*/_jsx("h4", {
      className: "text-sm text-text-blue font-heavy-font",
      children: "".concat(formattedLocations.length, " Location")
    });
  } else {
    locationText = !isEmpty(intlProvider) ? /*#__PURE__*/_jsx(FormattedMessage, {
      id: "NRZ/fl",
      description: "location-plural",
      defaultMessage: "Locations",
      children: txt => /*#__PURE__*/_jsx("h4", {
        className: "text-sm text-text-blue font-heavy-font",
        children: "".concat(formattedLocations.length, " ").concat(txt)
      })
    }) : /*#__PURE__*/_jsx("h4", {
      className: "text-sm text-text-blue font-heavy-font",
      children: "".concat(formattedLocations.length, " Locations")
    });
  }
  if (isEmpty(formattedLocations)) {
    return null;
  }
  const locationClass = () => cn({
    'border-b border-solid border-light-border-blue': true,
    'mb-2 pt-2 pb-2 last:border-0': true
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(className),
    children: [showCount && locationText, /*#__PURE__*/_jsx(AllOrOne, {
      showAll: showMore,
      children: formattedLocations.map(location => /*#__PURE__*/_jsx("div", {
        className: locationClass(),
        children: /*#__PURE__*/_jsx(Location, {
          clickableAddress: clickableAddress,
          hideLocationName: hideLocationName,
          isInNetworkGroup: isInNetworkGroup,
          location: location,
          originLatLng: originLatLng,
          showMore: showMore,
          additionalContentComponent: locationAdditionalContentComponent,
          intlProvider: intlProvider,
          showHoursIcon: showHoursIcon
        })
      }, location.id || uniqueId(location.name || location.displayName)))
    })]
  });
};
Locations.propTypes = {
  className: PropTypes.string,
  clickableAddress: PropTypes.bool,
  hideLocationName: PropTypes.bool,
  isInNetworkGroup: PropTypes.bool,
  locations: PropTypes.array,
  originLatLng: PropTypes.array,
  showCount: PropTypes.bool,
  showHoursIcon: PropTypes.bool,
  showMore: PropTypes.bool,
  /**
   * Property passed down to location component that will render in the main content area of the component.
   * This feature is used to render an edit location link.
   */
  locationAdditionalContentComponent: PropTypes.func,
  intlProvider: PropTypes.object
};
export default Locations;
//# sourceMappingURL=Locations.js.map